<div class="flex gap-x-6 gap-y-2 w-full">
  <form
    [formGroup]="financingFormGroup"
    class="grid gap-x-6 gap-y-2 w-full"
    [ngClass]="{
      'grid-cols-1': financingSectionColumm === 1,
      'grid-cols-1 lg:grid-cols-2 ': financingSectionColumm === 2,
    }"
  >
    <div class="aa-input-general gap-1 flex flex-col">
      <div class="text-general-title mb-2 text-(--color-segundo)">
        {{ 'quotation.titles.leaseData' | translate }}
      </div>
      <div class="flex flex-col gap-1">
        <div class="gap-1 flex flex-col">
          <mat-label class="text-(--comp-input-label-normal) px-4">{{
            'quotation.fieldNames.planType' | translate
          }}</mat-label>
          <mat-form-field class="input-mat-form-field w-full" appearance="outline">
            <mat-select formControlName="dealer" (selectionChange)="onChangeDealer($event)">
              @for (planType of planTypes; track planType.id) {
                <mat-option [value]="planType.id">
                  {{ planType.description }}
                </mat-option>
              }
            </mat-select>
            @if (financingFormGroup.controls['dealer'].hasError('required')) {
              <mat-error>{{ 'Campo requerido' }}</mat-error>
            }
          </mat-form-field>
        </div>

        <div class="gap-1 flex flex-col">
          <mat-label class="text-(--comp-input-label-normal) px-4">{{
            'quotation.titles.arrangement' | translate
          }}</mat-label>
          <mat-form-field class="input-mat-form-field w-full" appearance="outline">
            <mat-select formControlName="agreement" (selectionChange)="onChangePlan($event)">
              @for (plan of plans; track plan.id) {
                <mat-option [value]="plan.id">
                  {{ plan.description }}
                </mat-option>
              }
            </mat-select>
            @if (financingFormGroup.controls['agreement'].hasError('required')) {
              <mat-error>{{ 'Campo requerido' }}</mat-error>
            }
          </mat-form-field>
        </div>

        <div class="gap-1 flex flex-col">
          <mat-label class="text-(--comp-input-label-normal) px-4">{{
            'quotation.fieldNames.program' | translate
          }}</mat-label>
          <mat-form-field class="input-mat-form-field w-full" appearance="outline">
            <mat-select
              formControlName="arrangement"
              (selectionChange)="onChangeArrangement($event)"
            >
              @for (program of programs; track program.id) {
                <mat-option [value]="program.id">
                  {{ program.description }}
                </mat-option>
              }
            </mat-select>
            @if (financingFormGroup.controls['arrangement'].hasError('required')) {
              <mat-error>{{ 'Campo requerido' }}</mat-error>
            }
          </mat-form-field>
        </div>

        <div class="gap-1 flex flex-col">
          <mat-label class="text-(--comp-input-label-normal) px-4">{{
            'quotation.titles.insuranceCarrier' | translate
          }}</mat-label>
          <mat-form-field class="input-mat-form-field w-full" appearance="outline">
            <mat-select
              formControlName="insuranceCarrier"
              (selectionChange)="onChangeInsuranceCarrier($event)"
            >
              @for (ic of insurances; track ic.id) {
                <mat-option [value]="ic.id">
                  {{ ic.description }}
                </mat-option>
              }
            </mat-select>
            @if (financingFormGroup.controls['insuranceCarrier'].hasError('required')) {
              <mat-error>{{ 'Campo requerido' }}</mat-error>
            }
          </mat-form-field>
        </div>
      </div>
    </div>

    @if (showNext) {
      <div class="aa-input-general flex flex-col gap-4">
        <div class="text-general-subtitle mb-2 text-(--color-segundo)">
          {{ 'quotation.titles.installments' | translate }}
        </div>
        <div class="flex flex-col gap-4 justify-center items-center">
          <div class="houseDeadLines">
            <div class="">
              <div
                class="flex flex-wrap gap-2 justify-center"
                [ngClass]="{ errorCheckboxes: checkDeadlines <= 0 && isAuto }"
              >
                @for (deadLine of deadLines; track deadLine.id) {
                  <div
                    class="rounded-xl border border-(--comp-input-file-border) shadow-xl inset-shadow-sm flex p-2 gap-2 w-fit flex-col"
                  >
                    <div class="flex gap-2 justify-between pr-2">
                      <mat-checkbox
                        required
                        (change)="onChangeDeadLine($event, deadLine.id, deadLine.description)"
                        [checked]="isDeadLineSelected(deadLine.id)"
                      >
                        {{ deadLine.description }} {{ 'quotation.fieldNames.months' | translate }}
                      </mat-checkbox>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
          <div class="text-general-subtitle">{{ 'quotation.titles.coverage' | translate }}</div>
          <div class="houseDeadLines">
            <div class="">
              <div
                class="contenedor"
                [ngClass]="{ errorCheckboxes: checkCoverages <= 0 && isAuto }"
              >
                @for (coverage of coverages; track coverage.id) {
                  <div
                    class="rounded-xl border border-(--comp-input-file-border) shadow-xl inset-shadow-sm flex p-2 gap-2 w-fit flex-col"
                  >
                    <mat-checkbox
                      required
                      class="CheckSpearated"
                      [checked]="isCoverageSelected(coverage.id)"
                      (change)="onChangeCoverage($event, coverage.id, coverage.description)"
                    >
                      {{ coverage.description }}
                    </mat-checkbox>
                  </div>
                }
              </div>
            </div>
          </div>
          <button
            matButton="filled"
            color="primary"
            class="processButton"
            (click)="onSubmitFinancing()"
            [disabled]="!activeFinancing"
          >
            {{ 'quotation.labels.process' | translate }}
          </button>
        </div>
      </div>
    } @else {
      <div></div>
    }
  </form>
</div>
